import { Box } from "@mui/material";
import { memo, ReactNode } from "react";

export const FieldWrapper = memo(
  ({ children }: { children: ReactNode }): JSX.Element => {
    return <Box mb={2}>{children}</Box>;
  }
);
